import Autolinker from 'autolinker'

// v-htmlを使う際にXSS対策としてサニタイズしたリンクを生成するメソッド。
// v-htmlはfilterに対応していないようなので、mixinとして使用する
export default {
  methods: {
    sanitizedLink(v) {
      if (!v) return ''
      return Autolinker.link(v, {
        sanitizeHtml: true
      })
    }
  }
}